<template>
    <modal name="video-modal" width="50%" height="60%" :adaptive="true" class="modal__video">
        <div class="btn__close">
            <a href="#" @click.prevent="$modal.hide('video-modal')"><i class="fa fa-times" /></a>
        </div>
        <iframe
            :src="src"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
        />
    </modal>
</template>

<script>
export default {
    name: 'VideoModal',
    props: {
        src: {
            type: String,
            required: true
        }
    }
};
</script>
<style lang="scss">
    .modal__video {
        .v--modal-box {
            padding: 20px;

            @media (max-width: 990px) {
                width: 100% !important;
                left: 0 !important;
            }

            @media (max-width: 768px) {
                height: 350px !important;
            }

            @media (max-width: 575px) {
                height: 250px !important;
            }

            .btn__close {
                position: absolute;
                top: 5px;
                right: 5px;
                line-height: 0;
            }

            iframe {
                width: 100%;
                height: 100%;
            }
        }
    }
</style>
